// Ticker Tape Carousel - Simple vanilla JavaScript
var tickerTapeInstances = [];

function initTickerTapeCarousel(carousel) {
  // Prevent duplicate initialization
  if (carousel.dataset.initialized === 'true') {
    return;
  }
  carousel.dataset.initialized = 'true';

  var track = carousel.querySelector('.ticker-tape-carousel__track');
  var slides = carousel.querySelectorAll('.ticker-tape-carousel__slide');
  var playPauseButton = carousel.querySelector('.ticker-tape-carousel__play-pause');
  var playIcon = carousel.querySelector('.play-icon');
  var pauseIcon = carousel.querySelector('.pause-icon');

  if (!track || slides.length === 0) {
    return;
  }

  var speed = parseFloat(carousel.dataset.speed) || 30;
  var direction = carousel.dataset.direction || 'rtl';
  var isPlaying = true;
  var animationId = null;
  var lastTime = performance.now();

  // Clone slides for seamless loop
  for (var i = 0; i < slides.length; i++) {
    var clone = slides[i].cloneNode(true);
    track.appendChild(clone);
  }

  function getSlideWidth() {
    return slides[0].offsetWidth;
  }

  function getTotalWidth() {
    return getSlideWidth() * slides.length;
  }

  // Set initial position based on direction
  var currentPosition = direction === 'ltr' ? -getTotalWidth() : 0;

  // Set initial transform
  track.style.transform = 'translateX(' + currentPosition + 'px)';

  function animate() {
    if (!isPlaying) return;

    var currentTime = performance.now();
    var deltaTime = currentTime - lastTime;
    lastTime = currentTime;

    var movement = (speed * deltaTime) / 1000;
    var totalWidth = getTotalWidth();

    if (direction === 'rtl') {
      currentPosition -= movement;
      if (Math.abs(currentPosition) >= totalWidth) {
        currentPosition = 0;
      }
    } else {
      currentPosition += movement;
      if (currentPosition >= 0) {
        currentPosition = -totalWidth;
      }
    }

    track.style.transform = 'translateX(' + currentPosition + 'px)';
    animationId = requestAnimationFrame(animate);
  }

  function startAnimation() {
    if (animationId) return;
    isPlaying = true;
    lastTime = performance.now();
    animate();
    if (playIcon) playIcon.style.display = 'none';
    if (pauseIcon) pauseIcon.style.display = 'inline';
    if (playPauseButton) playPauseButton.setAttribute('aria-label', 'Pause carousel');
  }

  function pauseAnimation() {
    if (animationId) {
      cancelAnimationFrame(animationId);
      animationId = null;
    }
    isPlaying = false;
    if (playIcon) playIcon.style.display = 'inline';
    if (pauseIcon) pauseIcon.style.display = 'none';
    if (playPauseButton) playPauseButton.setAttribute('aria-label', 'Play carousel');
  }

  if (playPauseButton) {
    playPauseButton.addEventListener('click', function() {
      if (isPlaying) {
        pauseAnimation();
      } else {
        startAnimation();
      }
    });
  }

  startAnimation();

  // Store instance for cleanup if needed
  tickerTapeInstances.push({
    carousel: carousel,
    stop: pauseAnimation
  });
}

function initAllTickerTapes() {
  var carousels = document.querySelectorAll('.ticker-tape-carousel');
  for (var i = 0; i < carousels.length; i++) {
    initTickerTapeCarousel(carousels[i]);
  }
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllTickerTapes);
} else {
  initAllTickerTapes();
}

// Shopify theme editor support - CRITICAL for customizer
document.addEventListener('shopify:section:load', function(event) {
  // Wait a bit for DOM to be ready
  setTimeout(function() {
    var carousels = event.target.querySelectorAll('.ticker-tape-carousel');
    for (var i = 0; i < carousels.length; i++) {
      initTickerTapeCarousel(carousels[i]);
    }
  }, 100);
});

document.addEventListener('shopify:section:reorder', function(event) {
  setTimeout(function() {
    var carousels = event.target.querySelectorAll('.ticker-tape-carousel');
    for (var i = 0; i < carousels.length; i++) {
      initTickerTapeCarousel(carousels[i]);
    }
  }, 100);
});

document.addEventListener('shopify:section:select', function(event) {
  // Pause animation when section is selected in editor
  var carousels = event.target.querySelectorAll('.ticker-tape-carousel');
  for (var i = 0; i < carousels.length; i++) {
    var playPauseButton = carousels[i].querySelector('.ticker-tape-carousel__play-pause');
    if (playPauseButton) {
      playPauseButton.click(); // Pause for editing
    }
  }
});
